import type * as Types from '@xingternal/pages-graphql-types';

import * as Operations from './UpdatePageInfo.graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EntityPageUpdateConfigurationMutationVariables = Types.Exact<{
  pageId: Types.Scalars['SlugOrID']['input'];
  title?: Types.InputMaybe<Types.Scalars['String']['input']>;
  slogan?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type EntityPageUpdateConfigurationMutation = (
  { __typename?: 'Mutation' }
  & { entityPageUpdateConfiguration?: Types.Maybe<(
    { __typename?: 'EntityPageConfigUpdateResult' }
    & { error?: Types.Maybe<(
      { __typename?: 'EntityPagesMutationError' }
      & Pick<Types.EntityPagesMutationError, 'errorType' | 'errorCode'>
    )> }
  )> }
);


export type EntityPageUpdateConfigurationMutationFn = Apollo.MutationFunction<EntityPageUpdateConfigurationMutation, EntityPageUpdateConfigurationMutationVariables>;

/**
 * __useEntityPageUpdateConfigurationMutation__
 *
 * To run a mutation, you first call `useEntityPageUpdateConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEntityPageUpdateConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [entityPageUpdateConfigurationMutation, { data, loading, error }] = useEntityPageUpdateConfigurationMutation({
 *   variables: {
 *      pageId: // value for 'pageId'
 *      title: // value for 'title'
 *      slogan: // value for 'slogan'
 *   },
 * });
 */
export function useEntityPageUpdateConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<EntityPageUpdateConfigurationMutation, EntityPageUpdateConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EntityPageUpdateConfigurationMutation, EntityPageUpdateConfigurationMutationVariables>(Operations.EntityPageUpdateConfiguration, options);
      }
export type EntityPageUpdateConfigurationMutationHookResult = ReturnType<typeof useEntityPageUpdateConfigurationMutation>;
export type EntityPageUpdateConfigurationMutationResult = Apollo.MutationResult<EntityPageUpdateConfigurationMutation>;
export type EntityPageUpdateConfigurationMutationOptions = Apollo.BaseMutationOptions<EntityPageUpdateConfigurationMutation, EntityPageUpdateConfigurationMutationVariables>;